import TailwindSideModal from "../../../components/commonModal/TailwindSideModal";
import TailwindBottomButtonView from "../../../components/mainBottomButtonView/TailwindBottomButtonView";
import CommonSplitContainer from "../../../components/ui/layout/CommonSplitContainer/CommonSplitContainer";
import { ProductRegisterModalProps } from "../../product/productRegister/types/productTypes";
import LoadingOverlay from "../productList/components/LoadingOverlay";
import ProductInfoCard from "./components/ProductInfoCard";
import ProductUnitFormCard from "./components/ProductUnitFormCard";
import { useProductRegisterViewModel } from "./hooks/useProductRegisterViewModel";

/**
 * Tailwind rebuild of the legacy `ProductRegisterModal`
 * (src/screens/product/productRegister/ProductRegisterModal.tsx), following
 * the same shell used for the ingredient register redesign —
 * `TailwindSideModal` + `CommonSplitContainer` (scrollable top / fixed
 * bottom) + `TailwindBottomButtonView` — see
 * src/screens/lcaIngredients/ingredientRegister/IngredientRegisterModal.tsx.
 * All state/data-fetching lives in `useProductRegisterViewModel`; this
 * component only composes presentation.
 *
 * Drop-in replacement for the legacy modal wherever it's rendered (identical
 * props) — used from `ProductListNew.tsx`.
 */
const ProductRegisterModal = ({ visibleModal, setVisibleModal }: ProductRegisterModalProps) => {
  const vm = useProductRegisterViewModel({ visibleModal, setVisibleModal });

  return (
    <>
      <TailwindSideModal
        open={visibleModal}
        onOpenChange={open => {
          if (!open) vm.onCancel();
        }}
        title="Register product"
        titleClassName="tw-font-display"
      >
        <CommonSplitContainer
          currentHeight={0.9}
          overflowX="hidden"
          topChild={
            <div className="tw-flex tw-flex-col tw-gap-6 tw-bg-muted/20 tw-p-6">
              <ProductInfoCard vm={vm} />
              <ProductUnitFormCard vm={vm} />
            </div>
          }
          bottomChild={
            <TailwindBottomButtonView
              cancelButtonStatus
              saveButtonStatus
              saveTitle={vm.isRootProductYes ? "Save and Continue" : "Register product"}
              buttonSize="lg"
              cancelButton={vm.onCancel}
              saveButton={vm.onSave}
              saveDisable={vm.saveDisabled}
            />
          }
        />
      </TailwindSideModal>

      {vm.isSaving ? <LoadingOverlay /> : null}
    </>
  );
};

export default ProductRegisterModal;
